<template>
  <v-date-picker
    ref="datePicker"
    :key="key"
    v-model="datetimeData"
    locale="vi-VN"
    color="green"
    :first-day-of-week="2"
    :max-date="minMax.max"
    :min-date="minMax.min"
    :masks="masks"
    :attributes="attrs"
    :is-required="true"
    :disabled-dates="{ weekdays: disableWeekdays }"
    :mode="mode"
    is24hr
    hide-time-header
    style="position: relative"
    @input="
      formatted = dayjs($event)
      $emit(
        'input',
        mode === 'date'
          ? formatted.format('YYYY-MM-DD')
          : formatted.format('YYYY-MM-DD HH:mm')
      )
    "
  >
    <!-- :popover="{ placement: $screens({ default: 'left' }) }" -->
    <template v-slot="{ inputValue, togglePopover }">
      <div
        v-if="disabled"
        class="date-picker"
        style="opacity: 0; position: absolute; width: 100%; z-index: 2"
      />
      <div
        class="date-picker"
        :class="{ isError: isError, isDisabled: disabled }"
        @click="
          togglePopover({ placement: popOverDirection, container: 'body' })
        "
      >
        <!-- bind with v calendar  -->
        <input
          :disabled="disabled"
          :value="inputValue"
          class="vc-input"
          style="display: none"
          @click="
            togglePopover({ placement: popOverDirection, container: 'body' })
          "
        />
        <!-- v-on="inputEvents" -->
        <!-- :value="formatInputValue(inputValue)" -->

        <div style="display: flex; flex-direction: row">
          <calendar-input
            ref="otpInput0"
            :value="
              !!datetimeData
                ? dayjs(datetimeData).format('YYYY-MM-DD HH:mm')
                : null
            "
            :disabled="disabled"
            input-classes="otp-input"
            :should-auto-focus="false"
            :num-inputs="mode === 'date' ? 3 : 5"
            :min-max="minMax"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
          />
          <!-- <button @click="handleClearInput('otpInput0')">Clear Input</button> -->
        </div>
      </div>
    </template>
    <!-- <template v-slot:footer>
      <div class="vc-footer">
        <button class="btn second">초기화</button>
        <button class="btn tert">확인</button>
      </div>
    </template> -->
  </v-date-picker>
</template>

<script>
import * as dayjs from 'dayjs'
import CalendarInput from './CalendarInput.vue'

export default {
  components: {
    'calendar-input': CalendarInput
  },
  props: {
    mode: {
      type: String,
      default: 'dateTime' // date
    },
    value: null,
    minMax: {
      type: Object,
      default: () => ({ min: null, max: null }) // YYYY-MM-DD HH:mm
    },
    disabled: {
      type: Boolean
    },
    disableWeekdays: [],
    popOverDirection: {
      type: String,
      default: 'bottom-start'
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  // props: ['dateData', 'minMax'],

  data() {
    return {
      key: 1000,
      dateTimeMode: false,
      bgActive: false,
      masks: {
        inputDateTime24hr: [
          'DD-MM-YYYY HH:mm',
          'DD/MM/YYYY HH:mm',
          'YYYY-MM-DD HH:mm',
          'YYYY/MM/DD HH:mm'
        ],
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD', 'DD-MM-YYYY', 'DD/MM/YYYY']
        // title: ['YYYY년 MMM'],
        // dayPopover: 'MMM D, YYYY, WWW',
      },
      datetimeData: this.value,
      attrs: [
        {
          key: 'today',
          highlight: {
            color: '#346cec',
            fillMode: 'outline'
          },
          dates: new Date()
        }
        // {
        //   dot: 'red',
        //   dates: {
        //     weekdays: [1],
        //   },
        // },
        // {
        //   dot: 'blue',
        //   dates: {
        //     weekdays: [7],
        //   },
        // },
      ]
    }
  },

  computed: {
    dayjs() {
      return dayjs
    },
    log() {
      return console.log
    }
  },
  watch: {
    value(nv, ov) {
      if (this.value) {
        if (this.mode === 'datetime') {
          this.datetimeData = dayjs(this.value, 'YYYY-MM-DD HH:mm').format(
            'YYYY-MM-DD HH:mm'
          )
        } else {
          this.datetimeData = dayjs(this.value, 'YYYY-MM-DD').format(
            'YYYY-MM-DD HH:mm'
          )
        }
      } else {
        this.datetimeData = null
      }
      this.key++
    }
  },

  mounted() {
    // var customParseFormat = require('dayjs/plugin/customParseFormat')
    // dayjs.extend(customParseFormat)
    if (this.value) {
      if (this.mode === 'datetime') {
        this.datetimeData = dayjs(this.value, 'YYYY-MM-DD HH:mm').format(
          'YYYY-MM-DD HH:mm'
        )
      } else {
        this.datetimeData = dayjs(this.value, 'YYYY-MM-DD').format(
          'YYYY-MM-DD HH:mm'
        )
      }
    }
    if (this.mode === 'datetime') {
      this.dateTimeMode = true
    }
    document.addEventListener('keyup', event => {
      if ((event.keyCode === 8 || event.keyCode === 46) && this.bgActive) {
        this.date = null
      }
    })
  },
  methods: {
    handleOnComplete(value) {
      // convert back to 'backend' format
      if (this.mode === 'datetime') {
        this.datetimeData = dayjs(value, 'DD-MM-YYYY HH:mm').format(
          'YYYY-MM-DD HH:mm'
        )
      } else {
        this.datetimeData = dayjs(value, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
      this.$emit('input', this.datetimeData) // only emit out to parent when the input is complete
    },
    handleOnChange(value) {
      if (!value) {
        this.$emit('input', null) // or null
      }
    },
    handleClearInput(ref) {
      this.$refs[ref].clearInput()
    },

    onOpen() {
      this.bgActive = true
    },
    onClose() {
      this.bgActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================== V Calendar ========================================== //
.date-picker,
.date-picker-range {
  display: flex;
  align-items: center;
  position: relative;

  &:not(.date-picker-range) {
    height: 32px;
    padding: 0 10px;
    // border: solid 1px #d8dee5;
    border-radius: 5px;
    background: #f0f0f5 url('../../styles/images/svg/mci_calendar_icon.svg')
      no-repeat calc(100% - 10px) 50%;

    &.isError {
      border-color: red;
    }
    &.isDisabled {
      background: #f5f7fa;
    }
  }

  .vc-input {
    background: url('../../styles/images/svg/mci_calendar_icon.svg') no-repeat
      calc(100% - 10px) 50%;
    padding-left: 10px;
    // width: 160px;
    min-width: 160px;
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    font-size: 1rem;
    background-color: #f0f0f5;
    border: 1px solid red !important;
    border-radius: 5px;

    &:focus {
      border: 1px solid red !important;
    }

    &.isError {
      border: 1px solid red !important;
    }

    &:disabled {
      background: #eceef0;
    }
  }
}

.overrideWidth {
  width: 150px !important;
}

.dateTimeMode {
  width: 180px !important;
}
</style>
